<template>
  <div :class="['o-home-landing', ($license.shouldUpgrade && $store.getters.getAcademyShowHeaderMessage) ||
    $store.getters.getAcademyData.persona === undefined
      ? 'o-home-landing-upgrade' : '']">
    <MoleculeHomeLandingAccess/>
  </div>
</template>

<script>
export default {
  name: 'OrganismHomeLanding',

  components: {
    MoleculeHomeLandingAccess: () => import('@/components/molecules/MoleculeHomeLandingAccess')
  }
}
</script>
